
const button = {
  text: {
    submit: 'Enviar',
    cancel: 'Cancelar',
    clearFilter: 'Borrar filtros',
    close: 'Cerrar',
    create: 'Crear',
    edit: 'Editar',
    save: 'Guardar',
  },
};

export default button;
